import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import addToMailchimp from "gatsby-plugin-mailchimp";
import { validateEmail } from "../../../utils/common";

export default function SubscribePopup({ popUpClose, onClose, url }) {
  const [email, setEmail] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // document.body.style.overflow = "hidden";
    // return () => {
    //   document.body.style.overflow = "unset";
    // };
    document.getElementById("popup").style.visibility = "visible";
    document.getElementById("popup").style.opacity = "1";
    return () => {
      document.getElementById("popup").style.opacity = "0";
      setTimeout(() => {
        document.getElementById("popup").style.visibility = "hidden";
      }, 500);
    };
  }, []);

  async function handleFormSubmit(e) {
    e.preventDefault();
    if (validateEmail(email)) {
      setLoading(true);
      const result = await addToMailchimp(email, {
        FNAME: fname,
        LNAME: lname,
      });
      if (result?.result === "success") {
        // alert(result?.msg);
        if (typeof window !== "undefined" && window.dataLayer) {
          window.dataLayer.push({
            event: "generate_lead",
          });
        }
      } else {
        alert(result?.msg);
      }
      setLoading(false);
      setEmail("");
      if (popUpClose) {
        popUpClose();
      }
      window.open(url, "_blank");
    } else {
      alert("Invalid email address");
    }
  }
  return (
    <div
      className={`fixed top-0 transition-opacity duration-700  bottom-0 left-0 right-0 bg-black/30 z-[250] backdrop-blur-[4.5px]`}
      id="popup"
    >
      <div className="absolute blur-xl top-0 left-0 right-0 bottom-0" />
      <div className="flex h-full w-full justify-center items-center z-[160]">
        <div className="max-w-md w-full bg-white rounded-md">
          <span
            className="absolute z-[170] right-3 top-2 p-1 cursor-pointer"
            onClick={() => {
              onClose();
              if (popUpClose) {
                popUpClose();
              }
            }}
          >
            <MdClose size={35} color="#fff" />
          </span>

          <div className="py-[29px] px-[44px] relative">
            <div className="relative">
              <p className="font-primary text-black leading-[29px] text-base sm:text-[20px] font-semibold mb-3">
                Enter your details
              </p>
              <form onSubmit={handleFormSubmit} className="max-w-2xl space-y-5">
                <input
                  placeholder="First Name"
                  value={fname}
                  className="bg-transparent w-full outline-none border-2 border-solid border-primary h-10 px-2 rounded"
                  onChange={(e) => setFname(e.target.value)}
                  type="text"
                />
                <input
                  placeholder="Last Name"
                  value={lname}
                  className="bg-transparent w-full outline-none border-2 border-solid border-primary h-10 px-2 rounded"
                  onChange={(e) => setLname(e.target.value)}
                  type="text"
                />
                <input
                  placeholder="Enter Your email address"
                  value={email}
                  className="bg-transparent w-full outline-none border-2 border-solid border-primary h-10 px-2 rounded"
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                />
                <button
                  type="submit"
                  className={`inline-block max-w-xs w-full cursor-pointer px-[30px] leading-[38px] font-extrabold uppercase rounded-tl-[27px] rounded-br-[27px]
                  text-center no-underline whitespace-nowrap bg-white btn-secondary border border-solid box-border transition-all duration-200 ease-linear`}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
